import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import farmerInField from "../../assets/images/png/farmerAndBoy.png";

const FranchiseBenefits = () => {
  return (
    <div className="bg_clr_light_green py-5">
      <Container>
        <Row className="align-items-center flex-column-reverse flex-lg-row">
          <Col className="mt-4 mt-lg-0" lg={6}>
            <h2 className="mb-0 ff_heebo fw-bold fs_6xl_2">
              Franchise <span className="clr_dark_green"> Benefits</span>
            </h2>
            <div>
              <div className="d-flex align-items-start gap-2 mt-4">
                <div
                  style={{ marginTop: "7px" }}
                  className="benefits-dot"
                ></div>
                <p className="mb-0 text-dark-grey ff_heebo fs_md pe-3">
                  Access to a large and growing network of farmers and agri-tech
                  startups
                </p>
              </div>
              <div className="d-flex align-items-start gap-2 mt-2">
                <div
                  style={{ marginTop: "7px" }}
                  className="benefits-dot"
                ></div>
                <p className="mb-0 text-dark-grey ff_heebo fs_md pe-3">
                  Comprehensive training programs for franchise staff
                </p>
              </div>
              <div className="d-flex align-items-start gap-2 mt-2">
                <div
                  style={{ marginTop: "7px" }}
                  className="benefits-dot"
                ></div>
                <p className="mb-0 text-dark-grey ff_heebo fs_md pe-3">
                  Opportunities to provide a wide range of agricultural products
                  and services
                </p>
              </div>
              <div className="d-flex align-items-start gap-2 mt-2">
                <div
                  style={{ marginTop: "7px" }}
                  className="benefits-dot"
                ></div>
                <p className="mb-0 text-dark-grey ff_heebo fs_md pe-3">
                  Support from a well-established parent company with expertise
                  in agriculture and technology
                </p>
              </div>
              <div className="d-flex align-items-start gap-2 mt-2">
                <div
                  style={{ marginTop: "7px" }}
                  className="benefits-dot"
                ></div>
                <p className="mb-0 text-dark-grey ff_heebo fs_md pe-3">
                  Potential for significant returns on investment through
                  various revenue streams
                </p>
              </div>
            </div>
          </Col>
          <Col lg={6}>
            <div>
              <img className="w-100" src={farmerInField} alt="" />
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default FranchiseBenefits;
